const angular = require('angular');
const app = angular.module('learn-directives');
/**
 * Defines the comment count component
 * @argument {Application} Application injected to gain access to the global Application service
 * @argument {Saml} Saml injected to gain access to the Saml resource
 */
app.directive('samlSettings', ['Application', 'Authorization', 'Saml', '$http', '$q', '$translate', function (Application, Authorization, Saml, $http, $q, $translate) {
  return {
    restrict: "E",
    replace: true,
    scope : {
      type: "=?"
    },
    template: require('../../templates/directives/saml-settings.html'),
    controller: ['$scope', '$attrs', function ($scope, $attrs) {
      var self = this;
      self.user = Authorization.getAuthToken().user;
      var domain = Application.navigation.getHost();
      self.acs = domain + '/saml/consume';
      self.entityId = domain + '/saml/sp';

      self.xmlId = 'samlidpxml';
      self.settings = {};
      self.newSettings = {};
      self.changedSettings = {};
      self.defaultOptionSettings = {
        callbackUrl: '',
        bindings: [{name: String, value: String}],
        cert: '', // the IDP's public signing certificate used to validate the signatures of the incoming SAML Responses, see Security and signatures
        signatureAlgorithm: 'sha1', // optionally set the signature algorithm for signing requests, valid values are 'sha1' (default), 'sha256', or 'sha512'
        digestAlgorithm: '', // optionally set the digest algorithm used to provide a digest for the signed data object, valid values are 'sha1' (default), 'sha256', or 'sha512'
        xmlSignatureTransforms: '',
        metadata: '',
        metadata_type: 'xml',
        disableRequestedAuthnContext: true, //if truthy, do not request a specific authentication context. This is known to help when authenticating against Active Directory (AD FS) servers.
        forceAuthn: false, //if set to true, the initial SAML request from the service provider specifies that the IdP should force re-authentication of the user, even if they possess a valid session.
        authnRequestBinding: 'HTTP-POST',
        idpIssuer: '', //if provided, then the IdP issuer will be validated for incoming Logout Requests/Responses. For ADFS this looks like https://acme_tools.windows.net/deadbeef
        signAuthnRequest: false,
        name_type: 'email',
      };

      self.copySettings = {
        signin_sso: false,
        sso_copy: {sso_button: 'Sign in with SSO'}
      };

      self.optionSettings = Object.assign({}, self.defaultOptionSettings);

      self.exists = false;

      function readFile(event) {
        var parser = new DOMParser();
        self.optionSettings.metadata = event.target.result;
        self.changedSettings.metadata = true;
        var xmlDoc = parser.parseFromString(event.target.result, 'text/xml');
        Application.messaging.addMessage({type: 'info', text: 'Metadata successfully uploaded. Please verify and save for changes to take affect.', duration: 7});
        $scope.$apply();
      };

      $scope.$watch('saml.file', function(newVal, oldVal) {
        if (newVal && newVal !== oldVal) {
          var reader = new FileReader();
          reader.addEventListener('load', readFile);
          reader.readAsText(self.file);
        }
      });

      self.openXML = function() {
        document.getElementById(self.xmlId).click();
      };

      self.translation = function(type){
        return ('{ saml: "' + type + '" }')
      };

      self.translations = {};

      self.useAdvanced = function() {
        self.optionSettings = Object.assign({}, self.defaultOptionSettings);
        self.newSettings.use_options = true;
        self.activeTab = 'editWithOptions';
      };

      self.cancelPreOptions = function() {
        self.newSettings.url = '';
        self.newSettings.cert = '';
        self.newSettings.use_options = false;
        self.activeTab = 'initial';
      };

      self.updatePreOptions = function() {
        if (!self.newSettings.url || !self.newSettings.cert) {
          Application.messaging.addMessage({type: 'error', text: self.translations['samlSettings.fill_all_fields'], duration: 5});
          return;
        }
        self.newSettings.use_options = false;
        self.loading = true;
        Saml.update({subresource: 'update'}, self.newSettings).$promise.then(function(data) {
          self.settings = data;
          Application.messaging.addMessage({type: 'success', text: self.translations['samlSettings.update_successful'], duration: 5});
          self.cancel();
          self.loading = false;
        }).catch(function(err) {
          Application.messaging.addMessage({type: 'error', text: self.translations['samlSettings.error_updating'], duration: 5});
        });
      };

      var validateXml = function() {
        var type = self.optionSettings.metadata_type;
        var data = self.optionSettings.metadata;
        if (!type || !data) {
          var deferred = $q.defer();
          deferred.reject();
          return deferred.promise;
        }

        return $http.post('/saml/validate-xml', {type: type, metadata: data, overrides: {
          entityIdOverride: self.optionSettings.entityIdOverride || '',
          bindingUrlOverride: self.optionSettings.bindingUrlOverride || '',
          certificateOverride: self.optionSettings.certificateOverride || ''
        }});
      };

      var parseIdpMetadata = function() {
        var type = self.optionSettings.metadata_type;
        var data = self.optionSettings.metadata;
        if (!type || !data) {
          var deferred = $q.defer();
          deferred.reject();
          return deferred.promise;
        }

        return $http.post('/saml/idp-metadata', {type: type, metadata: data});
      };

      self.generateIdpOptions = function() {
        parseIdpMetadata()
        .then(function(results) {
          self.parsedIdpValues = results && results.data || {};
          self.showIdpValues = true;
        }).catch(function(error) {
          console.log('Error in xml link or data.');
        });
      };

      self.updateWithOptions = function() {
        validateXml()
        .then(function(results) {
          if (!results.data || !results.data.valid) {
            console.log('invalid metadata or url');
            Application.messaging.addMessage({type: 'error', duration: 5, text: 'The provided metadata or settings are invalid.'});
            return;
          }

          var body = {
            use_options: true,
            options: self.optionSettings,
            signin_sso: self.copySettings.signin_sso || false,
            sso_copy: self.copySettings.sso_copy || {}
          };

          return Saml.update({subresource: 'update'}, body).$promise
        }).then(function(results) {
          Application.messaging.addMessage({type: 'success', duration: 5, text: 'SAML settings saved!'});
        }).catch(function(error) {
          Application.messaging.addMessage({type: 'error', duration: 5, text: 'There was an error saving the SAML settings.'});
          console.log('error: ', error)
        });
      };

      self.initialize = function() {
        self.loading = true;
        if (!self.user || !self.user.role || self.user.role !== 'admin') {
          Application.navigation.back();
          return;
        }

        Saml.get({}).$promise.then(function(settings) {
          self.activeTab = 'editWithOptions';
          if (settings._id) {
            if (!settings.use_options && (settings.url !== 'none' && settings.cert !== 'none')) {
              self.oldStyle = true;
              self.activeTab = 'editPreOptions';
            }
            self.exists = true;
            self.settings = settings;
            self.copySettings.signin_sso = settings.company.signin_sso || false;
            self.copySettings.sso_copy = settings.company.sso_copy || {sso_button: 'Sign in with SSO'};
            if (settings.options) {
              self.optionSettings = Object.assign({}, self.defaultOptionSettings, settings.options);
            }

            self.optionSettings.entityIdOverride = self.optionSettings.entityIdOverride || '';
            self.optionSettings.bindingUrlOverride = self.optionSettings.bindingUrlOverride || '';
            self.optionSettings.certificateOverride = self.optionSettings.certificateOverride || '';

            if (self.optionSettings.entityIdOverride || self.optionSettings.bindingUrlOverride || self.optionSettings.certificateOverride) {
              self.showOverrides = true;
            }

          }
          self.loading = false;
        }).catch(function(err) {
          Application.messaging.addMessage({type: 'error', text: self.translations['samlSettings.config_error'], duration: 5});
          self.loading = false;
          console.log(err);
        });
      };
    
      $translate([
        'samlSettings.fill_all_fields',
        'samlSettings.update_successful',
        'samlSettings.error_updating',
        'samlSettings.fill_all_fields',
        'samlSettings.config_success',
        'samlSettings.config_error',
        'samlSettings.config_error'
      ]).then(function(translations){
        self.translations = translations;
        self.initialize();
      });

    }],
    controllerAs: 'saml'
  }
}]);
